<template>
  <div class="app-container">
    <left-nav v-if="$route.meta.show_leftnav" class="left-nav" />
    <div class="content" :class="{ 'no-nav': !$route.meta.show_leftnav, 'with-nav': $route.meta.show_leftnav }">
      <router-view />
    </div>
  </div>
</template>

<script>
import LeftNav from '@/components/LeftNav.vue';

export default {
  name: 'App',
  components: {
    LeftNav
  }
}
</script>

<style>
.app-container {
  display: flex;
  height: 100vh;
  font-size: 1.2rem;
}

.left-nav {
  width: 250px;
  position: fixed;
  height: 100%;
}

.content {
  margin-left: 250px;
  flex-grow: 1;
  overflow-y: auto;
}

.content.no-nav {
  margin-left: 0;
  width: 100%; 
}

.content.with-nav {
  padding-left: 24px;
}

#app {
  font-family: Tahoma, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
}

.btn-khk {
  color: #2962FF;
  background-color: #2962FF;
}
</style>
